import services from '../services';

let timeout: number;

/**
 * Validates the email domain for the library and returns the result along with the library name.
 * @param email - The email address to validate
 * @param library - The library identifier
 * @returns {Promise<{ valid: boolean, libraryName?: string }>}
 */
const hasValidLibraryDomain = async (
  email: string,
  library: string
): Promise<{ valid: boolean; libraryName?: string }> => {
  if (!email) return { valid: false };

  if (timeout) {
    window.clearTimeout(timeout);
  }

  return new Promise((resolve) => {
    timeout = window.setTimeout(async () => {
      const { hasValidLibraryDomain, libraryName } = await services.user.hasValidLibraryDomain(email, library);
      resolve({ valid: hasValidLibraryDomain, libraryName });
    }, 200);
  });
};

export default hasValidLibraryDomain;
